import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Cliques por dia',
  aria: 'Gráfico de cliques por dia',
  clicks: {
    zero: '{{count}} cliques',
    one: '{{count}} clique',
    other: '{{count}} cliques',
  },
  hidden: 'menos de 20 pessoas',
  hiddenLegend: 'Barras tracejadas: dias com menos de 20 pessoas, sem número.',
  allHidden: 'Todos os dias do período tiveram menos de 20 pessoas: os números ficam nos totais.',
  max: 'máximo {{value}}',
  empty: 'Nenhuma impressão no período.',
} satisfies TranslationTree;
